package view

import com.soywiz.kds.iterators.fastForEachWithIndex
import com.soywiz.korge.view.Container
import com.soywiz.korio.async.runBlockingNoJs
import com.soywiz.korio.dynamic.serialization.parseTyped
import com.soywiz.korio.dynamic.serialization.stringifyTyped
import com.soywiz.korio.file.std.resourcesVfs
import com.soywiz.korio.serialization.json.Json
import game.Game
import game.Tile
import game.wishlairObjectMapper

class TileTemplatePalette(game: Game, private val toolPalette: ToolPalette) : Container() {
    private val tileTemplateFileName = "dev/tile-templates.json"

    val tileWidth = 8
    val tileHeight = 32
    val tileCount = tileWidth * tileHeight

    private var templates = List<Tile>(tileCount) { Tile() }

    var onTemplateSelect: ((Tile) -> Unit)? = null

    val terminal: Terminal = terminal(game.font, tileWidth, tileHeight)

    init {
        terminal.onClickChar = {
            val tile = templates[it.row * tileWidth + it.col]

            if (it.ctrl) {
                // Set template
                with(tile) {
                    char = toolPalette.charTool.char
                    fgColor = toolPalette.charTool.fgColor
                    bgColor = toolPalette.charTool.bgColor
                    type = toolPalette.charTool.type
                }

                runBlockingNoJs {
                    writeTemplates()
                }

                updatePalette()
            } else {
                // Set tool
                    with(toolPalette.charTool) {
                        char = tile.char
                        fgColor = tile.fgColor
                        bgColor = tile.bgColor
                        type = tile.type
                    }
                val index = it.row * tileWidth + it.col

                onTemplateSelect?.invoke(templates[index])
            }
        }

        runBlockingNoJs {
            if (resourcesVfs[tileTemplateFileName].exists()) {
                readTemplates()
            }
        }
    }

    fun setTemplate(templateIndex: Int, template: Tile) {
        with(templates[templateIndex]) {
            char = template.char
            fgColor = template.fgColor
            bgColor = template.bgColor
            type = template.type
        }
    }

    private suspend fun readTemplates() {
        val mapper = wishlairObjectMapper()

        val json = resourcesVfs[tileTemplateFileName].readString()
        templates = Json.parseTyped<TileList>(json, mapper).tiles

        updatePalette()
    }

    suspend fun writeTemplates() {
        val mapper = wishlairObjectMapper()

        val tileList = TileList(templates)

        val json = Json.stringifyTyped(tileList, mapper, true)
        resourcesVfs[tileTemplateFileName].writeString(json)
    }

    private fun updatePalette() {
        templates.fastForEachWithIndex { index, tile ->
            val col = index % tileWidth
            val row = index / tileWidth

            with(terminal.getChar(col, row)) {
                char = tile.char
                fgColor = tile.fgColor
                bgColor = tile.bgColor
            }
        }
    }

    class TileList(val tiles: List<Tile>)
}